// extracted by mini-css-extract-plugin
export default {"list":"Nav_list__aWH6+","item":"Nav_item__Y2DF7","link":"Nav_link__HOTcf","linkDark":"Nav_linkDark__NFyBt"};